import { OperationSpec, OperationType } from '@sqior/js/operation';

/** Switches the event playback */
export const EventPlaybackPath = 'event-playback';
export function SetEventPlayback(active: boolean): OperationSpec<boolean> {
  return { type: OperationType.Add, path: EventPlaybackPath, data: active };
}
